import { CareerCategory } from '@backrs_ui/common-ui';

import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { Page, View } from '@react-pdf/renderer';

import { resultPageStyles } from './resultPDF.styles';
import { BestFitCareerPathsPDF } from '../atoms/BestFitCareerPathsPDF';
import { SuggestedCareerPathsPDF } from '../molecules/SuggestedCareerPathsPDF';

type PageTwoProps = Readonly<{
  careerPathSuggestions: CareerPathWithScore[];
  careerPathCategories: CareerCategory[];
}>;

export function ResultPageTwo({ careerPathSuggestions, careerPathCategories }: PageTwoProps) {
  const sortedBySumCareerPath = [...careerPathSuggestions].sort((a, b) => b.sum - a.sum);

  return (
    <Page size="LETTER" style={resultPageStyles.pageFont}>
      <View style={resultPageStyles.bestFitCareerPathsContainer}>
        <BestFitCareerPathsPDF topThreeCareerPathsWithScore={sortedBySumCareerPath.slice(0, 3)} />
      </View>
      <View style={resultPageStyles.suggestedCareerPathsContainer}>
        <SuggestedCareerPathsPDF
          careerPathSuggestions={sortedBySumCareerPath}
          careerPathCategories={careerPathCategories}
        />
      </View>
    </Page>
  );
}
